// Base URL for the Neighbars redesign assets, served from the Azure CDN.
// AZURE_BASE_URL is injected at build time (craco DefinePlugin) and points to
// https://cdn-phcentral.azureedge.net/my-heineken/assets in prod.
export const REDESIGN_ASSETS_BASE = `${AZURE_BASE_URL}/redesign`
